export default __webpack_public_path__ + "static/media/high-priority-icon.b73a10d8.svg";